import styled, { css, keyframes } from 'styled-components';
import { device } from '../breakpoints';
import { playGrey10, playGrey15 } from '../design-tokens';
import { getChannelLayout } from './ChannelLayout.styles';
import { getDefaultLayout } from './DefaultLayout.styles';
import { getHeaderTextLayout } from './HeaderTextLayout.styles';
import { getHeroLayout } from './HeroLayout.styles';
import { getLetterGridLayout } from './LetterGridLayout.styles';
import { getShowcaseLayout } from './Showcase.styles';
import { PLACEHOLDER_LAYOUT } from './PlaceHolder';
import { imgPadding16By9, imgPadding2By3 } from '../PlayImage/PlayImage.styles';

const fadeAnimation = keyframes`
    0% {
        background-color: ${playGrey10};
    }

    15% {
        background-color: ${playGrey15};
    }

    30% {
        background-color: ${playGrey10};
    }

    100% {
        background-color: ${playGrey10};
    }
`;

const commonRowStyling = css`
    height: 15px;
    margin-top: 10px;
    background-color: ${playGrey10};
`;

export const StyledRow1 = styled.div`
    background: ${playGrey10};
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: ${fadeAnimation};
    border-radius: 5px;
    padding: ${(props) => (props.layout === PLACEHOLDER_LAYOUT.PORTRAIT ? imgPadding2By3 : imgPadding16By9)};
`;

export const StyledRow2 = styled.div`
    ${commonRowStyling}
    width: 80%;
`;

export const StyledRow3 = styled.div`
    ${commonRowStyling}
    width: 60%;
`;

export const StyledRow4 = styled.div`
    ${commonRowStyling}
    display: none;
`;

const getAnimationDelay = () => {
    return [...new Array(12)].map((item, i) => {
        return css`
            :nth-child(${i + 1}) ${StyledRow1} {
                animation-delay: ${i * 150}ms;
            }
        `;
    });
};

export const StyledPlaceHolderItem = styled.div`
    display: inline-block;
    margin-bottom: 30px;
    width: calc(50% - 2px);

    ${getAnimationDelay()}

    @media ${device.GteXsmall} {
        width: calc(33.3% - 2px);
    }

    @media ${device.GteMedium} {
        width: calc(25% - 2px);
    }
`;

const getLayout = (layout) => {
    switch (layout) {
        case PLACEHOLDER_LAYOUT.DEFAULT:
            return getDefaultLayout();
        case PLACEHOLDER_LAYOUT.SHOWCASE:
            return getShowcaseLayout();
        case PLACEHOLDER_LAYOUT.PORTRAIT:
            return getDefaultLayout();
        case PLACEHOLDER_LAYOUT.COLUMN:
            return css`
                flex-direction: column;
            `;
        case PLACEHOLDER_LAYOUT.HEADER_TEXT:
            return getHeaderTextLayout();
        case PLACEHOLDER_LAYOUT.HERO:
            return getHeroLayout();
        case PLACEHOLDER_LAYOUT.LETTER_GRID:
            return getLetterGridLayout();
        case PLACEHOLDER_LAYOUT.CHANNELS:
            return getChannelLayout();
        default:
            return null;
    }
};

export const StyledPlaceHolder = styled.div`
    display: flex;
    width: 100%;
    overflow: hidden;
    ${(props) => getLayout(props.layout)};
`;
